import CustomText from "@/components/ui/text/custom-text";
import cn from "@/hooks/class-names";
import useDynamicTranslation from "@/hooks/use-universal-transalation";
import Image from "next/image";
import React from "react";
import nicdc_logo from "@/assets/images/nicdc_logo.png";
import Link from "next/link";
import {
  Facebook,
  Twitter,
  Linkedin,
  Youtube,
  MailIcon,
  PhoneIcon,
} from "lucide-react";

function XIcon(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 1200 1227"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M714.6 564.8L1159.9 0H1052.7L667.8 483.7L362.4 0H0L473.3 723.6L0 1227H107.2L518.5 712.5L837.7 1227H1200L714.6 564.8Z" />
    </svg>
  );
}

const SocailLinks = [
  { icon: <XIcon className="w-4 h-4" />, url: "https://x.com/nicdc01" },
  { icon: <Facebook />, url: "https://www.facebook.com/NICDC01" },
  { icon: <Linkedin />, url: "https://www.linkedin.com/company/nicdc/" },
  { icon: <Youtube />, url: "https://www.youtube.com/c/NICDC" },
];
const currentYear = new Date().getFullYear();
const fileUrls = "/assets/pdfs/investors/F&Q.pdf";

export default function Footer() {
  const { getTranslated, renderTranslated } = useDynamicTranslation(["footer"]);
  return (
    <div>
      <div
        className={cn(
          "bg-black text-white",
          "p-10 laptop:p-10 laptop-large:p-20"
        )}
      >
        <div
          className={cn(
            "grid grid-cols-1 laptop:grid-cols-5 laptop-large:grid-cols-5 gap-4 "
          )}
        >
          {/* column1 */}
          <div className=" border-white">
            <div className="flex laptop:justify-center">
              <Image
                src={nicdc_logo}
                className="w-[16%] laptop:w-[60%] laptop-large:w-[30%]"
                alt="NICDC Logo"
              />
            </div>
          </div>
          {/* column 2 */}
          <div className=" border-white ">
            <div className="laptop:my-5">
              <ul>
                <li>
                  <Link href={"/"} target="_blank" className="group">
                    <CustomText
                      text={getTranslated("title", "footer.child.01")}
                      className={cn(
                        "laptop:text-[14px] capitalize group-hover:cursor-pointer"
                      )}
                    />
                  </Link>
                </li>
                <li>
                  <Link
                    href={"/about/our-journey"}
                    target="_blank"
                    className="group"
                  >
                    <CustomText
                      text={getTranslated("01", "footer.child.01.navlinks")}
                      className={cn(
                        "laptop:text-[14px] capitalize group-hover:cursor-pointer"
                      )}
                    />
                  </Link>
                </li>
                <li>
                  <Link
                    href={"/about/board-of-directors"}
                    target="_blank"
                    className="group"
                  >
                    <CustomText
                      text={getTranslated("02", "footer.child.01.navlinks")}
                      className={cn(
                        "laptop:text-[14px] capitalize group-hover:cursor-pointer"
                      )}
                    />
                  </Link>
                </li>
                <li>
                  <Link
                    href={"/cyber-jagrookta-diwas"}
                    target="_blank"
                    className="group"
                  >
                    <CustomText
                      text={getTranslated("03", "footer.child.01.navlinks")}
                      className={cn(
                        "laptop:text-[14px] capitalize group-hover:cursor-pointer"
                      )}
                    />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          {/* column3 */}
          <div className=" border-white">
            <div className="laptop:my-5">
              <ul>
                <li>
                  <Link href={"/nicdc-media/news-and-events"} className="group">
                    <CustomText
                      text={getTranslated("01", "footer.child.02.navlinks")}
                      className={cn(
                        "laptop:text-[14px] capitalize group-hover:cursor-pointer"
                      )}
                    />
                  </Link>
                </li>
                <li>
                  <Link href={"/careers/nicdc-openings"} className="group">
                    <CustomText
                      text={getTranslated("02", "footer.child.02.navlinks")}
                      className={cn(
                        "laptop:text-[14px] capitalize group-hover:cursor-pointer"
                      )}
                    />
                  </Link>
                </li>
                <li>
                  <Link href={"/contact"} className="group">
                    <CustomText
                      text={getTranslated("03", "footer.child.02.navlinks")}
                      className={cn(
                        "laptop:text-[14px] capitalize group-hover:cursor-pointer"
                      )}
                    />
                  </Link>
                </li>
                <li>
                  <Link href={fileUrls} target="_blank" className="group">
                    <CustomText
                      text={getTranslated("04", "footer.child.02.navlinks")}
                      className={cn(
                        "laptop:text-[14px] capitalize group-hover:cursor-pointer"
                      )}
                    />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          {/* column4 */}
          <div className=" border-white">
            <div className="laptop:my-5">
              <ul className="space-y-1">
                <li>
                  <div className="mb-2">
                    <CustomText
                      text={getTranslated("title", "footer.child.03")}
                      className={cn("uppercase font-bold")}
                    />
                  </div>
                </li>
                <li>
                  <Link
                    href={"mailto:contactus@nicdc.in"}
                    className="group flex items-center"
                  >
                    <MailIcon className="h-4" />
                    <CustomText
                      text={getTranslated("01", "footer.child.03.navlinks")}
                      className={cn(
                        "laptop:text-[14px] group-hover:cursor-pointer"
                      )}
                    />
                  </Link>
                </li>
                <li>
                  <Link
                    href={"tel:011-23317884"}
                    className="group flex items-center"
                  >
                    <PhoneIcon className="h-4" />
                    <CustomText
                      text={getTranslated("02", "footer.child.03.navlinks")}
                      className={cn(
                        "laptop:text-[14px] group-hover:cursor-pointer"
                      )}
                    />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className=" border-white laptop:flex laptop:justify-end laptop-large:justify-start">
            <div className="laptop:my-5">
              <div className="mb-2">
                <CustomText
                  text={getTranslated("title", "footer.child.04")}
                  className={cn("uppercase font-bold")}
                />
              </div>
              <ul className="flex space-x-3 items-center">
                {SocailLinks?.map((ele, index) => (
                  <li key={index}>
                    <Link href={ele?.url} target="_blank">
                      {ele?.icon}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="text-center my-4">
          <CustomText
            text={
              <p
                className={cn(
                  "laptop:text-[14px] capitalize group-hover:cursor-pointer"
                )}
              >
                © {currentYear} NICDC. All Rights Reserved. Powered by{" "}
                <span>
                  <a
                    className="text-orange font-bold"
                    href="https://negd.gov.in/"
                  >
                    NeGD
                  </a>
                </span>
              </p>
            }
          />
        </div>
      </div>
    </div>
  );
}
